/* eslint-disable */
import axios from "axios";
import jwtDecode from "jwt-decode";
import Cookies from "js-cookie";

import { BASE_URL } from "../../api";

export const REFRESH_TOKEN_COOKIE_NAME = "_odd_auth";

const updatePassword = (access, username, password) => {
  return axios({
    url: `${BASE_URL}/api/token/`,
    data: { access, username, password },
    method: "POST"
  }).then(response => response.data);
};

const forgotPassword = username => {
  return axios({
    url: `${BASE_URL}/api/token/`,
    data: { username },
    method: "POST"
  }).then(response => response.data);
};

const password = {
  forgot: forgotPassword,
  update: updatePassword
};

const setRefreshToken = refreshToken => {
  return Cookies.set(REFRESH_TOKEN_COOKIE_NAME, refreshToken, {
    expires: 3,
    sameSite: "strict"
  });
};

const removeRefreshToken = () => {
  return Cookies.remove(REFRESH_TOKEN_COOKIE_NAME);
};

const getRefreshToken = () => {
  return Cookies.get(REFRESH_TOKEN_COOKIE_NAME);
};

export const refreshToken = {
  set: setRefreshToken,
  get: getRefreshToken,
  remove: removeRefreshToken
};

export const requestTokens = (username, password) => {
  return axios({
    url: `${BASE_URL}/api/token/`,
    data: { username, password },
    method: "POST"
  }).then(response => response.data);
};

export const requestAccessToken = refresh => {
  return axios({
    url: `${BASE_URL}/api/token/refresh/`,
    data: { refresh },
    method: "POST"
  }).then(response => response.data);
};

export const tokenExpirationInMilliseconds = token => {
  try {
    const decoded = jwtDecode(token);
    // Calculate percentage in milliseconds
    return !!decoded ? decoded.exp * 1000 - new Date().getTime() : null;
  } catch (error) {
    return -1;
  }
};

export default {
  password,
  refreshToken,
  requestTokens,
  requestAccessToken,
  tokenExpirationInMilliseconds
};
